import React from 'react';
import { AdminContent } from './admin';
import { UnlockedAdminContent } from './first-unlocked-admin';
import type { ContentProps } from './types';
import { UserContent } from './user';

export const Content = ({ isFirstUnlocked, isAdmin }: ContentProps) => {
	if (isFirstUnlocked) {
		return <UnlockedAdminContent />;
	}
	if (isAdmin) {
		return <AdminContent />;
	}
	return <UserContent />;
};
